import ApiService from '@/services/core/api.service'

const ScheduleDriversService = {
  async get (query) {
    return ApiService.get(`logistics-officer/schedule/drivers?${query}`)
  },

  async histories (query) {
    return ApiService.get(`logistics-officer/reports/schedule/driver-histories?${query}`)
  },

  async exports (query) {
    return ApiService.get(`logistics-officer/export/schedule/driver-histories?${query}`)
  },

  async post (payload) {
    return ApiService.post('logistics-officer/schedule/drivers', payload)
  },

  async put (payload) {
    return ApiService.put(`logistics-officer/schedule/drivers/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`logistics-officer/schedule/drivers/${payload.id}`)
  }
}

export default ScheduleDriversService
